import { ErrorMessage, Field } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SignatureCanvas from "react-signature-canvas";
import { formatDateTime } from "../../utils/dateFormat";
import AudioRecordButton from "../form/AudioRecordButton";
import Input from "../form/Input";

function SignaturePadCard({
  title,
  signatureRef,
  fieldName,
  signatureFieldName,
  signatureDateFieldName,
  setFieldValue,
  onClear,
  onToggleLock,
  lockField,
  disabled,
  defaultImage,
  defaultCollapsed,
}) {
  const { t } = useTranslation();
  const [hasDrawn, setHasDrawn] = useState(false);
  const [lastStrokeAt, setLastStrokeAt] = useState(null);
  const [showingDefaultImage, setShowingDefaultImage] = useState(!!defaultImage);
  const [collapsed, setCollapsed] = useState(!!defaultCollapsed);


  const canvasVisible = !showingDefaultImage;
  const clearDisabled = !showingDefaultImage && !hasDrawn;
  const clearButtonClassName = clearDisabled ? "btn btn-default" : "btn btn-warning";

  return (
    <div className="card border-0 mb-4">
      <div
        className="card-header h6 mb-0 bg-none p-3"
        style={{ cursor: "pointer" }}
        onClick={() => setCollapsed((prev) => !prev)}
      >
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <i
              className={`fa fa-${collapsed ? "chevron-right" : "chevron-down"} fa-fw text-dark text-opacity-50 me-1 d-md-none`}
            />
            <i className="fa fa-pencil fa-lg fa-fw text-dark text-opacity-50 me-1 d-none d-md-inline" />
            {title}
          </div>
          {!collapsed && (
            <div className="btn-group" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                onClick={onToggleLock}
                className="btn btn-default"
                disabled={!canvasVisible || !hasDrawn}
              >
                <i className={`fa fa-${lockField ? "lock" : "unlock"}`} />{" "}
                <span className="d-none d-md-inline">{t(lockField ? "common.unlock" : "common.lock")}</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  if (lockField && onToggleLock) onToggleLock();
                  if (!showingDefaultImage) {
                    onClear();
                  }
                  setShowingDefaultImage(false);
                  setHasDrawn(false);
                  setLastStrokeAt(null);
                  if (signatureFieldName && setFieldValue) {
                    setFieldValue(signatureFieldName, "");
                  }
                  if (signatureDateFieldName && setFieldValue) {
                    setFieldValue(signatureDateFieldName, "");
                  }
                }}
                className={clearButtonClassName}
                disabled={clearDisabled}
              >
                <i className="fa fa-eraser" /> <span className="d-none d-md-inline">{t("common.delete")}</span>
              </button>
            </div>
          )}
        </div>
      </div>
      <div className={collapsed ? "d-md-block" : ""} style={collapsed ? { visibility: "hidden", maxHeight: 0, overflow: "hidden" } : undefined}><div className="card-body">
        <div className="row">
          <div className={`col ${canvasVisible ? "border-bottom border-2" : ""} ${lockField ? "bg-light" : ""}`}>
            {showingDefaultImage ? (
              <img src={defaultImage} alt="" className="mx-auto mw-100 d-block" />
            ) : (
              <SignatureCanvas
                penColor="black"
                clearOnResize={false}
                canvasProps={{ className: "signature-pad" }}
                ref={signatureRef}
                onEnd={() => {
                  setHasDrawn(true);
                  const now = new Date();
                  setLastStrokeAt(now);
                  if (signatureFieldName && setFieldValue) {
                    setFieldValue(signatureFieldName, "drawn");
                  }
                  if (signatureDateFieldName && setFieldValue) {
                    setFieldValue(signatureDateFieldName, now.toISOString());
                  }
                }}
              />
            )}
          </div>
        </div>
        {signatureFieldName && (
          <ErrorMessage
            name={signatureFieldName}
            render={(msg) => <div className="text-danger small mt-1">{msg}</div>}
          />
        )}
        <div className="row mt-2">
          <div className="col">
            <label className="form-label" htmlFor={fieldName}>
              {t("common.full_name")}
            </label>
            <div className="input-group">
              <Field component={Input} name={fieldName} className="form-control fs-13px h-45px" disabled={disabled} />
              {!disabled && (
                <AudioRecordButton
                  onTranscription={(text) => {
                    setFieldValue(fieldName, text);
                  }}
                />
              )}
            </div>
            <ErrorMessage name={fieldName} render={(msg) => <div className="invalid-feedback">{t(msg)}</div>} />
            {signatureDateFieldName && lastStrokeAt && (
              <small className="text-muted mt-1 d-block">{formatDateTime(lastStrokeAt)}</small>
            )}
          </div>
        </div>
      </div></div>
    </div>
  );
}

export default SignaturePadCard;
